import { skills } from "../Inc/data";
import Container from "./../Components/Container";
import { FaHtml5 } from "react-icons/fa";

export default function About() {
  return (
    <section id="about" className="min-h-[calc(100vh-70px)] snap-start">
      <Container innerPadding="" outterPadding="">
        <div className="p-6 pb-0">
          <div className="flex flex-col items-center">
            <div className="text-sky-800 font-extrabold">About Me</div>
            <div className="text-2xl font-semibold">Who is Happy Lakudzala</div>
            <div className="h-1 bg-sky-800 w-36 my-2"></div>
          </div>
          <div className="flex gap-4">
            <div className="hidden lg:flex lg:mt-0 lg:col-span-2 rounded-full h-72 w-72 border shadow-sm">
              <img
                src="/img/iamhq_no-bg.png"
                alt="header-image"
                className="rounded-full h-72 w-72 object-cover"
              />
            </div>
            <div className="flex-1">
              <div className="flex flex-col gap-3 my-3 space-y-6 text-md lg:text-lg text-justify">
                <p>
                  I am a data and technology enthusiast with a
                  knack for transforming complex information into clear insights
                  and practical solutions. By day, I work in telecommunications
                  as a Business Intelligence and Data Analyst, building
                  dashboards, designing automated pipelines, and optimizing data
                  systems that empower decision-making.
                </p>
                <p>
                  I thrive at the intersection of data, design, and
                  problem-solving, whether that means creating user-friendly
                  applications, digging into research, or experimenting with new
                  technologies. My goal is simple: use data and software to
                  solve real problems and create tools that make life smarter
                  and easier.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-10">
          <div className="flex flex-col items-center">
            <div className="text-sky-800 font-extrabold">My Skills</div>
            <div className="text-2xl font-semibold">
              What I can do for your need
            </div>
            <div className="h-1 bg-sky-800 w-36 my-2"></div>
          </div>

          <div className="grid md:grid-cols-3 gap-2 p-2">
            {skills.map((skill, index) => (
              <div key={index} className="p-4 rounded-lg border shadow-sm bg-sky-800 border-sky-800 text-white">
                <div className="flex flex-col items-center gap-2">
                  <div className="flex">
                    <div className="p-4 rounded-full text-sky-800 bg-white text-xl">
                      {skill.icon ? skill.icon : <FaHtml5 />}
                    </div>
                  </div>
                  <div className="w-full">
                    <div className="font-bold text-center text-lg">
                      {skill.name}
                    </div>
                    <ul className="text-justify list-disc list-inside">
                      {skill.attributes.map((attr, i) => (
                        <li key={i} className="">
                          {attr}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
